export default __webpack_public_path__ + "static/media/01.9bc818cb.jpg";